import React, { useState, useEffect } from 'react';

import { ReactComponent as SpinnerUpIcon } from 'assets/images/number-spinner-up.svg';
import { ReactComponent as SpinnerDownIcon } from 'assets/images/number-spinner-down.svg';

import { parseCSSNumberValue } from './utilities';

import './index.scss';

function CSSNumberValueControl(props) {

  const [value, setValue] = useState(props.value + '');

  useEffect(function onValueChange() {

    const result = parseCSSNumberValue(value);
    props.onChange(result.validValue);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  function handleValueChange(value) {

    const result = parseCSSNumberValue(value);

    let _value = value;

    if (value.indexOf(result.unit) !== -1) {
      _value = _value.substring(0, _value.indexOf(result.unit) + result.unit.length);
    } else if (value.indexOf('auto') === 0) {
      _value = 'auto';
    }

    setValue(_value);

  }

  function incrementValue(direction) {

    const result = parseCSSNumberValue(value);

    if (result.validValue === 'auto') {
      return;
    }

    const newNumber = result.number + direction;

    let _value = newNumber + '';

    if (value.indexOf(result.unit) !== -1) {
      _value += result.unit;
    }

    setValue(_value);

  }

  function handleKeyDownEvent(event) {

    const key = event.key;
    const shiftKey = event.shiftKey;

    if (key !== 'ArrowUp' && key !== 'ArrowDown') {
      return;
    }

    const direction = key === 'ArrowUp' ? 1 : -1;
    const multiplier = shiftKey === true ? 10 : 1;

    incrementValue(direction * multiplier);

  }

  function renderMain() {

    const inputAttributes = {
      className: 'css-number-value-control',
      value,
      onChange: function handleChange(event) {
        handleValueChange(event.target.value);
      },
      onKeyDown: handleKeyDownEvent
    };

    return <div className="css-number-value-control-main">
      <input {...inputAttributes} />
      <div className="css-number-value-spinners">
        <button
          className="css-number-value-spinner css-number-value-spinner-up"
          tabIndex={-1}
          onMouseDown={function handleUp(event) {
            event.preventDefault();
            incrementValue(1);
          }}
        >
          <SpinnerUpIcon />
        </button>
        <button
          className="css-number-value-spinner"
          tabIndex={-1}
          onMouseDown={function handleDown(event) {
            event.preventDefault();
            incrementValue(-1);
          }}
        >
          <SpinnerDownIcon />
        </button>
      </div>
    </div>;

  }

  return renderMain();

}

export default CSSNumberValueControl;
